import { ChangeDetectorRef, Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { Subject, Subscription } from 'rxjs';
import { TranslatePipe } from '@ngx-translate/core';
import { UiAtomButtonComponent } from '../../atoms/ui-atom-button/ui-atom-button.component';

export interface ExportProgressDialogData {
  progress$: Subject<number>;
  cancel$: Subject<void>;
}

@Component({
  selector: 'ui-molecule-dialog-export-progress',
  standalone: true,
  imports: [MatProgressBarModule, TranslatePipe, UiAtomButtonComponent],
  templateUrl: './ui-molecule-dialog-export-progress.component.html',
  styleUrl: './ui-molecule-dialog-export-progress.component.scss',
})
export class UiMoleculeDialogExportProgressComponent implements OnInit, OnDestroy {
  protected progress = 0;
  private progressSub?: Subscription;

  constructor(
    private dialogRef: MatDialogRef<UiMoleculeDialogExportProgressComponent>,
    private cdr: ChangeDetectorRef,
    @Inject(MAT_DIALOG_DATA) public data: ExportProgressDialogData,
  ) {}

  ngOnInit(): void {
    this.progressSub = this.data.progress$.subscribe((p) => {
      this.progress = p;
      this.cdr.markForCheck();
    });
  }

  ngOnDestroy(): void {
    this.progressSub?.unsubscribe();
  }

  protected onCancel(): void {
    this.data.cancel$.next();
  }
}
